var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoCodigoBarrasAlternativo01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1507",
    d: "M8.3,7.6H6.7c-0.3,0-0.6,0.3-0.6,0.6v7.9c0,0.3,0.3,0.6,0.6,0.6h1.6c0.3,0,0.6-0.3,0.6-0.6V8.2 C8.9,7.9,8.6,7.6,8.3,7.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1508",
    d: "M8.3,19.3H6.7c-0.3,0-0.6,0.3-0.6,0.6v7.9c0,0.3,0.3,0.6,0.6,0.6h1.6c0.3,0,0.6-0.3,0.6-0.6v-7.9 C8.9,19.5,8.6,19.3,8.3,19.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1509",
    d: "M14.5,16.7h1.6c0.3,0,0.6-0.3,0.6-0.6V8.2c0-0.3-0.3-0.6-0.6-0.6h-1.6c-0.3,0-0.6,0.3-0.6,0.6v7.9 C13.9,16.5,14.2,16.7,14.5,16.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1510",
    d: "M16.1,19.4h-1.6c-0.3,0-0.6,0.3-0.6,0.6v6.2c0,0.3,0.3,0.6,0.6,0.6h1.6c0.3,0,0.6-0.3,0.6-0.6V20 C16.7,19.7,16.5,19.4,16.1,19.4C16.1,19.4,16.1,19.4,16.1,19.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1511",
    d: "M27.7,16.7h1.6c0.3,0,0.6-0.3,0.6-0.6V8.2c0-0.3-0.3-0.6-0.6-0.6h-1.6c-0.3,0-0.6,0.3-0.6,0.6v7.9 C27.1,16.5,27.4,16.7,27.7,16.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1512",
    d: "M27.7,28.4h1.6c0.3,0,0.6-0.3,0.6-0.6v-7.9c0-0.3-0.3-0.6-0.6-0.6h-1.6c-0.3,0-0.6,0.3-0.6,0.6v7.9 C27.1,28.1,27.4,28.4,27.7,28.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1513",
    d: "M25,16.7h0.6c0.3,0,0.5-0.2,0.5-0.5V8c0-0.3-0.2-0.5-0.5-0.5H25c-0.3,0-0.5,0.2-0.5,0.5v8.2 C24.5,16.5,24.7,16.7,25,16.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1514",
    d: "M25.6,19.4H25c-0.3,0-0.5,0.2-0.5,0.5v6.5c0,0.3,0.2,0.5,0.5,0.5h0.6c0.3,0,0.5-0.2,0.5-0.5v-6.5 C26,19.6,25.8,19.4,25.6,19.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1515",
    d: "M18.3,16.7h0.6c0.3,0,0.5-0.2,0.5-0.5V8c0-0.3-0.2-0.5-0.5-0.5h-0.6c-0.3,0-0.5,0.2-0.5,0.5v8.2 C17.8,16.5,18,16.7,18.3,16.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1516",
    d: "M18.9,19.4h-0.6c-0.3,0-0.5,0.2-0.5,0.5v6.5c0,0.3,0.2,0.5,0.5,0.5h0.6c0.3,0,0.5-0.2,0.5-0.5v-6.5 C19.3,19.6,19.1,19.4,18.9,19.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1517",
    d: "M11.7,16.7h0.6c0.3,0,0.5-0.2,0.5-0.5V8c0-0.3-0.2-0.5-0.5-0.5h-0.6c-0.3,0-0.5,0.2-0.5,0.5v8.2 C11.3,16.5,11.5,16.7,11.7,16.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1518",
    d: "M12.3,19.4h-0.6c-0.3,0-0.5,0.2-0.5,0.5v6.5c0,0.3,0.2,0.5,0.5,0.5h0.6c0.3,0,0.5-0.2,0.5-0.5v-6.5 C12.8,19.6,12.6,19.4,12.3,19.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1519",
    d: "M22.3,16.7h0.6c0.3,0,0.5-0.2,0.5-0.5V8c0-0.3-0.2-0.5-0.5-0.5h-0.6c-0.3,0-0.5,0.2-0.5,0.5v8.2 C21.8,16.5,22,16.7,22.3,16.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1520",
    d: "M22.9,19.4h-0.6c-0.3,0-0.5,0.2-0.5,0.5v6.5c0,0.3,0.2,0.5,0.5,0.5h0.6c0.3,0,0.5-0.2,0.5-0.5v-6.5 C23.4,19.6,23.2,19.4,22.9,19.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1521",
    d: "M34.2,3.2H28c-0.7,0-1.3,0.6-1.3,1.3c0,0.7,0.6,1.3,1.3,1.3c0,0,0,0,0,0h4.9v4.9c0,0.7,0.6,1.3,1.3,1.3 s1.3-0.6,1.3-1.3V4.5C35.5,3.8,34.9,3.2,34.2,3.2z M34.9,10.7c0,0.4-0.3,0.6-0.6,0.6s-0.6-0.3-0.6-0.6V5.4c0-0.2-0.1-0.3-0.3-0.3 H28c-0.4,0-0.6-0.3-0.6-0.6c0-0.4,0.3-0.6,0.6-0.6h6.2c0.4,0,0.6,0.3,0.6,0.6c0,0,0,0,0,0V10.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1522",
    d: "M1.8,11.9c0.7,0,1.3-0.6,1.3-1.3V5.7H8c0.7,0,1.3-0.6,1.3-1.3c0-0.7-0.6-1.3-1.3-1.3c0,0,0,0,0,0H1.8 c-0.7,0-1.3,0.6-1.3,1.3v6.2C0.5,11.4,1.1,11.9,1.8,11.9L1.8,11.9L1.8,11.9z M1.1,4.5c0-0.4,0.3-0.6,0.6-0.6H8 c0.4,0,0.6,0.3,0.6,0.6c0,0.4-0.3,0.6-0.6,0.6l0,0H2.7c-0.2,0-0.3,0.1-0.3,0.3v5.3c0,0.4-0.3,0.6-0.6,0.6c-0.4,0-0.6-0.3-0.6-0.6 L1.1,4.5L1.1,4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1523",
    d: "M8,30.3H3.1v-4.9c0-0.7-0.6-1.3-1.3-1.3c-0.7,0-1.3,0.6-1.3,1.3v6.2c0,0.7,0.6,1.3,1.3,1.3H8 c0.7,0,1.3-0.6,1.3-1.3C9.2,30.8,8.7,30.3,8,30.3C8,30.3,8,30.3,8,30.3L8,30.3z M8,32.2H1.8c-0.4,0-0.6-0.3-0.6-0.6v-6.2 c0-0.4,0.3-0.6,0.6-0.6c0.4,0,0.6,0.3,0.6,0.6l0,0v5.3c0,0.2,0.1,0.3,0.3,0.3H8c0.4,0,0.6,0.3,0.6,0.6C8.6,31.9,8.3,32.2,8,32.2 L8,32.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1524",
    d: "M34.2,24.1c-0.7,0-1.3,0.6-1.3,1.3v0v4.9H28c-0.7,0-1.3,0.6-1.3,1.3c0,0.7,0.6,1.3,1.3,1.3h6.2 c0.7,0,1.3-0.6,1.3-1.3v-6.2C35.5,24.6,34.9,24.1,34.2,24.1L34.2,24.1z M34.9,31.5c0,0.4-0.3,0.6-0.6,0.6h0H28 c-0.4,0-0.6-0.3-0.6-0.6c0-0.4,0.3-0.6,0.6-0.6h5.2c0.2,0,0.3-0.1,0.3-0.3v-5.3c0-0.4,0.3-0.6,0.6-0.6s0.6,0.3,0.6,0.6L34.9,31.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1525",
    d: "M1.3,18c0,0.2,0.1,0.3,0.3,0.3c0,0,0,0,0,0h32.8c0.2,0,0.3-0.1,0.3-0.3c0-0.2-0.1-0.3-0.3-0.3H1.6 C1.4,17.7,1.3,17.8,1.3,18C1.3,18,1.3,18,1.3,18z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCodigoBarrasAlternativo01);
export default __webpack_public_path__ + "static/media/ico-codigo-barras-alternativo-01.3dc146d93caf6f5d6ec7e2ce3229f5d5.svg";
export { ForwardRef as ReactComponent };